/** @jsx jsx */
import PropTypes from "prop-types"
import { jsx, Styled, Box, useThemeUI } from "theme-ui"

import { Small } from "components/type"

const Paper = ({
  className,
  color,
  bg,
  children,
  rotation,
  holeColor,
  cite,
}) => {
  const { theme } = useThemeUI()
  return (
    <Box
      className={className}
      sx={{
        bg,
        borderRadius: 10,
        my: 4,
        p: 4,
        pl: 5,
        position: "relative",
        transform: `rotate(${rotation}deg)`,
        "&:before": {
          background: `transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E%3Ccircle cx='12.473' cy='12.473' r='7.474' fill='%23${theme.colors[
            holeColor
          ].substr(1)}' /%3E%3C/svg%3E") round 0 0`,
          backgroundSize: "100% auto",
          bottom: 2,
          content: '""',
          color: holeColor,
          left: 2,
          position: "absolute",
          top: 2,
          width: "1.5rem",
        },
      }}
    >
      <Styled.p
        sx={{ color, fontFamily: "handwriting", fontSize: [3, 4, 5], my: 0 }}
      >
        {children}
      </Styled.p>
      {cite ? (
        <Small sx={{ color, fontWeight: "medium", mb: 0 }}>{cite}</Small>
      ) : null}
    </Box>
  )
}

Paper.defaultProps = {
  holeColor: "background",
  bg: "muted",
  color: "primary",
  rotation: -3,
}

Paper.propTypes = {
  bg: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.any,
  rotation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  holeColor: PropTypes.string,
  cite: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

export default Paper
